import { FxAvatar, FxIcon } from '@/components/fx'

const STEPS = [
  {
    title: 'Ausgefülltes Formular hochladen',
    detail: 'Foto, Scan oder PDF – eine Seite genügt.',
  },
  {
    title: 'Wir finden die Felder',
    detail: 'Kästchen, Textfelder und Unterschriften, automatisch.',
  },
  {
    title: 'Werte ansehen und exportieren',
    detail: 'Jedes Feld mit seiner Sicherheit – als Excel oder CSV.',
  },
]

/**
 * The register screen's right-hand column: what happens after the account,
 * and what the test costs.
 *
 * It appears only for someone who arrived through the funnel, because that
 * is the only visitor for whom "so geht's weiter" is a promise about the
 * next thirty seconds rather than a sales pitch.
 */
export function FunnelAside() {
  return (
    <aside className="flex flex-col justify-center gap-7 bg-primary-subtle px-6 py-12 md:px-14 md:py-[72px]">
      <p className="text-small font-semibold tracking-[0.04em] text-primary-text">
        SO GEHT&apos;S WEITER
      </p>
      <p className="text-tile-title text-text">In einer halben Minute zum ersten Ergebnis</p>

      <ol className="flex list-none flex-col gap-[18px] p-0">
        {STEPS.map((step, index) => (
          <li key={step.title} className="flex gap-3.5">
            <FxAvatar
              initials={String(index + 1)}
              size={32}
              filled={index === 0}
              className="font-semibold"
              aria-hidden="true"
            />
            <span>
              <b className="text-body-strong">{step.title}</b>
              <br />
              <span className="text-small text-text">{step.detail}</span>
            </span>
          </li>
        ))}
      </ol>

      <div className="flex items-center gap-3.5 rounded-sm bg-surface px-5 py-4 shadow-raised">
        <FxIcon name="redeem" size={28} className="shrink-0 text-primary" />
        <span>
          <b className="text-body-strong">Der Test ist kostenlos.</b>
          <br />
          {/* No figure: the signup grant is a config value
              (`billing.signup_credits`, 200 by default) that no endpoint
              reports, and it buys a different number of pages per operation —
              so any count named here would be a guess. Once signed in, the
              header's quota line and the result screen quote the real
              numbers. */}
          <span className="text-small text-text">
            Danach bekommst du ein Startguthaben für deine ersten Seiten. Mehr kaufst du nur, wenn
            du es brauchst.
          </span>
        </span>
      </div>
    </aside>
  )
}
